module.exports = __webpack_public_path__ + "img/galleryBanner.7de26b85.webp";